import { action, observable } from 'mobx';
import RestEndPoint from './RestEndPoint';
import { APIUrlConstants, AppConstants } from './APIConstants';
import { removeData } from 'jquery';

class CommonStore {
  @observable childComponent = '';
  @observable referenceNavigation = '';
  @observable showLoader = false;
  @observable showGridLoader = false;
  @observable currentScreen = {};
  @observable screenDetails = [];
  @observable screenWrappers = [];
  @observable reportDetails = [];

  dialogBoxAction = {};
  @observable dialogBox = {
    showDialog: false,
    title: '',
    body: ''
  };

  @action
  hideLoaderOnlyIfShowing() {
    if (this.showLoader === true) {
      this.showLoader = false;
    }
  }

  @action
  async getScreens() {
    //const { data } = await RestEndPoint.call(APIUrlConstants.GetScreens,'GET')//, 
    const { data } = await RestEndPoint.callAzureFunction(APIUrlConstants.GetScreens,'GET',AppConstants.APP_BACKEND_HOST_KEY); //--need to undo while checking in
    if(data.message)
      window.toastr.info(data.message);
    else
       this.screenDetails = data;

      // this.hideLoaderOnlyIfShowing();
}



@action
  async getReports() {
    
    const { data } = await RestEndPoint.callAzureFunction(APIUrlConstants.GetReports,'GET',AppConstants.APP_BACKEND_HOST_KEY); //--need to undo while checking in
    if(data.message)
      //window.toastr.info(data.message);
      console.log(data.message);
    else
       this.reportDetails = data;


}

@action
async getScreenWrappers() {
  const { data } = await RestEndPoint.callAzureFunction(APIUrlConstants.GetScreensWrapper,'GET',AppConstants.APP_BACKEND_HOST_KEY); //--need to undo while checking in
  if(data.message)
    window.toastr.info(data.message);
  else
     this.screenWrappers = data;
}
  @action
  toggleLoader() {
    this.showLoader = !this.showLoader;
  }
  @action
  showLoaderModel() {
    this.showLoader = false;
  }
  @action
  stopLoader() {
    this.showLoader = false;
  }
  
  @action
  setValueOfChildComponent(value) {
    this.childComponent = value;
  }

  /**
   * Method to show confirmation dialog
   * @param {} title
   * @param {} body
   * @param {} action
   */
  showConfirmationDialog(title, body, action) {
    this.dialogBox.showDialog = true;
    this.dialogBox.title = title;
    this.dialogBox.body = body;
    typeof action === 'function'
      ? (this.dialogBoxAction = action)
      : (this.dialogBoxAction = function () {});
  }

  @action
  /**
   * Method to call end point
   */
  callEndPoint() {
    this.dialogBoxAction();
  }
}
export default new CommonStore();
